<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"> </router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // // 动态决定哪些组件需要被缓存
      // includedComponents:[]
    };
  },
};
</script>
<style lang="scss">
#app {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.container {
  width: 1280px;
  margin: 0 auto;
}
img {
  display: block;
}
.img_inline img{
  display: inline-block;
}
.flex {
  display: flex;
}
.flex_content_center {
  justify-content: center;
}
.flex_content_sb {
  justify-content: space-between;
}
.flex_content_end {
  justify-content: flex-end;
}
.flex_items_center {
  align-items: center;
}
.flex_wrap {
  flex-wrap: wrap;
}
.fb,
.color{
  transition: all 0.3s;
}
.fb:hover{
  font-weight:500 !important;
}
.color:hover{
  color:#000 !important;
}
// 公用二级页面底纹 dxm
.bg_wrap {
  width: 100%;
  margin-top: 93px;
  padding-top: 50px;
  padding-bottom: 300px;
  min-height: 600px;
  background: url("assets/imgs/sencon_bg.png");
  background-size: 100% auto;
}
@media only screen and (max-width: 1280px) {
  .container {
    width: 90%;
  }
}
@media only screen and (max-width: 767px) {
  .bg_wrap {
    width: 100%;
    padding-top: 30px;
    background: #EEF0F3 url("assets/imgs/m_bg.png") no-repeat;
    background-size: 100%;
    margin-top: 1.15rem;
  }
}
</style>
